export default __webpack_public_path__ + "static/media/logo.111ea8a3.png";